<template>
  <a-entity portal visible="false" position="0 0 0">
    <!-- We can define assets here to be loaded while the load screen is displayed -->
    <!-- textures -->
    <img id="posx" src="/cubemap/jupiter/posx.png">
    <img id="posy" src="/cubemap/jupiter/posy.png">
    <img id="posz" src="/cubemap/jupiter/posz.png">
    <img id="negx" src="/cubemap/jupiter/negx.png">
    <img id="negy" src="/cubemap/jupiter/negy.png">
    <img id="negz" src="/cubemap/jupiter/negz.png">
    <img id="skybox-img" crossorigin>
    <img id="shadow" crossorigin>
    <!-- <video
      id="portal-video"
      muted
      autoplay
      playsinline
      crossorigin
      loop="true"
    ></video> -->
    <!-- Camera -->

    <!-- Hider walls -->
    <a-entity id="hider-walls">
      <a-box
        scale="100 1 100"
        position="0 -1 49"
        xrextras-hider-material
      />
      <!--back wall-->
      <a-box
        scale="100 100 1"
        position="0 50 25"
        xrextras-hider-material
      />

      <!--floor -->
      <a-box
        scale="100 100 1"
        position="0 0 50"
        rotation="0 0 0"
        color="grey"
        xrextras-hider-material
      />
      <!--left-->
      <a-box
        scale="100 1 100"
        position="0 100 49"
        material="shader: flat;"
        xrextras-hider-material
      />
      <!--left wall-->
      <a-box
        scale="1 100 100"
        position="-30 50 50"
        color="grey"
        xrextras-hider-material
      />
      <!--right wall-->
      <a-box
        scale="1 100 100"
        position="30 50 50"
        color="grey"
        material="shader: flat;"
        xrextras-hider-material
      />

      <!--RECT ENTRANCE-->
      <a-entity id="portal-entrance-rect" visible="true">
        <!-- 20 width (50-30) -->
        <a-plane
          width="50"
          height="150"
          position="-30 0 0"
          color="grey"
          xrextras-hider-material
        />
        <a-plane
          width="50"
          height="150"
          position="30 0 0"
          color="grey"
          xrextras-hider-material
        />
        <a-plane
          width="60"
          height="100"
          position="0 65 0"
          color="grey"
          xrextras-hider-material
        />
      </a-entity>

      <a-entity id="portal-entrance-circle" visible="false">
        <a-ring
          id="portalHiderRing"
          radius-inner="3.5"
          radius-outer="100"
          position="0 7.5 -0.2"
          color="tomato"
          xrextras-hider-material
        />
      </a-entity>
    </a-entity>

    <!--portal exit from inside-->
    <a-entity id="portal-wall">
      <a-entity visible="false">
        <a-circle
          radius="5.2"
          rotation="0 180 0"
          position="0 7.5 0"
          scale="0.8 0.8 0"
          xrextras-hider-material
        />
        <a-circle
          radius="5.2"
          rotation="0 180 0"
          position="0 7.5 0.25"
          scale="0.8 0.8 0"
          xrextras-hider-material
        />
      </a-entity>
      <a-plane
        visible="true"
        height="35"
        width="10"
        rotation="180 0 0"
        position="0 0 0.25"
        xrextras-hider-material
      />
    </a-entity>

    <!-- Lights -->
    <!-- <a-entity
      light="
        type: directional;
        castShadow: true;
        shadowMapHeight:2048;
        shadowMapWidth:2048;
        shadowCameraTop: 35;
        shadowCameraBottom: -20;
        shadowCameraRight: 40;
        shadowCameraLeft: -10;
        target: #portalPolygon"
      xrextras-attach="target: portalPolygon; offset: 0 0 0"
      shadow
    /> -->

    <!-- <a-light type="ambient" intensity="8" position="0, 0, 0" /> -->

    <!-- <a-entity
      light="type: directional; color: #ffffff; intensity: 1; castShadow: true"
      position="1, -50, 0"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1; castShadow: true"
      position="0, -50, 10"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1; castShadow: true"
      position="-50, -50, 50"
    /> -->
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1.5; castShadow: true"
      position="5, 3, 5"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 0.8; castShadow: true"
      position="-3, 2, 3"
    />
    <a-entity
      light="type: directional; color: #ffffff; intensity: 1.2; castShadow: true"
      position="0, 4, -5"
    />

    <a-entity
      loading
      scale="1 1 1"
      position="0 0 0"
    />

    <!-- Portal Contents -->
    <a-entity id="portal-contents">
      <a-entity
        id="portalGround"
        visible="false"
        geometry="primitive: circle; radius: 35;"
        material="color: #333333"
        rotation="0 0 0"
        position="0 35w -55"
        scale="1 1 1"
        shadow="cast: false"
        env-map="resolution:256;
        repeat: true;
        interval: 50;
        roughness: 1.0;
        metalness: 0.0;
        mat-override:false"
      />
      <a-entity
        id="portalPolygon"
        animation-mixer="clip: *"
        position="0 0 0"
        rotation="0 0 0"
        cubemap-static
        env-map="resolution:256;
        repeat: true;
        interval: 50;
        roughness: 0.0;
        metalness: 0.0;
        mat-override:false"
      />
      <a-entity
        id="portalLight"
        position="0 5 -35"
        scale=".70 .70 .70"
        spin="axis: y; speed: 60000"
        env-map="resolution:256;
        repeat: true;
        interval: 50;
        roughness: 0.0;
        metalness: 0.0;
        mat-override:false"
      />
      <!--add reward polygon
      todo learn how to load an external file into aframe-->
      <a-entity
        id="portalReward"
        visible="false"
        class="clickable"
        position="0 0 0"
        rotation="0 0 0"
        env-map="resolution:256;
        repeat: true;
        interval: 50;
        roughness: 0.1;
        metalness: 1.0;
        mat-override:false"
      />
      <!-- material="shader: custom; color: blue; opacity: 0.7; transparent: true;" -->
      <a-sky src="#skybox-img" rotation="0 7 0" />
    </a-entity>
    <!--realtime cubemap is what displays the outside world, in-->
    <a-entity
      id="portalRim"
      cubemap-realtime
      position="0 7.75 0"
      rotation="90 -90 -90"
      scale="0.001 0.001 0.001"
      shadow="receive: false"
    />
    <a-circle
      id="portalShadow"
      radius="0.5"
      material="src: #shadow; opacity: 0.65; roughness: 0.8; metalness: 0"
      position="0 0.01 1.25"
      rotation="0 0 0"
      scale="0.001 0.001 0.001"
    />
  </a-entity>
</template>
<script>
export default {
  data () {
    return { position: { x: 0, y: 0, z: 0 } }
  }
}
</script>
